import '@babel/polyfill'
import Vue from 'vue'
import VueAxios from './plugins/axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  VueAxios,
  vuetify,
  render: h => h(App)
}).$mount('#app')
